<span [class]="skinName">
  @if (footerSlug) {
    <span [routerLink]="['/app/page', footerSlug]" id="footerLinkText" class="cursor-pointer">{{footerNavText}}</span>
  }

</span>